export default "__VITE_ASSET__2564d145__";